import React from 'react';
import HeaderNavbar from '../components/HeaderNavbar';
import Footer from '../components/Footer';

function Platform() {
  return (
    <>
      <HeaderNavbar />
      <div className="row">
        <div className="col-12">
          <h1>Platform</h1>
          <p>This page is under construction.</p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Platform;

